import { getFinancialItemType } from 'src/financial/financial-data/financialItemEntityType';
import { MantineStyleProps } from '@mantine/core';
import { DynamicUiEntitiesMetadata } from 'src/UI/dynamicUI/types';
import { BaseFinancialItem, Liability } from 'src/financial/financial-data/hooks/useFinancialItems';
import {
  FinancialItemGenericTable,
  formatDate,
} from 'src/financial/financial-data/tables/FinancialItemGenericTable';
import { formatMoney } from 'src/common/currency';
import { useCurrency } from 'src/common/hooks/useCurrency';

type AccountsTableProps = {
  liabilities: Liability[];
  metadata: DynamicUiEntitiesMetadata;
  pl?: MantineStyleProps['pl'];
  pr?: MantineStyleProps['pr'];
  titleParts?: string[];
  onSubmit: () => void;
  onRowClick: (clickedItem: BaseFinancialItem) => void;
};

export default function LiabilitiesTable({
  liabilities,
  metadata,
  pl = 50,
  onRowClick,
}: AccountsTableProps) {
  const currency = useCurrency();
  const fieldsRenderingRules = [
    {
      headerTitle: 'Description',
      sortable: true,
      sortKey: 'description',
      render: (item: Liability) =>
        item.description?.length && item.description.length > 50
          ? item.description.slice(0, 50) + '...'
          : item.description,
    },
    {
      headerTitle: 'Provider',
      sortable: true,
      sortKey: 'provider',
      render: (item: Liability) => item.provider,
    },
    {
      headerTitle: 'Type',
      sortable: true,
      sortKey: 'type',
      render: (item: Liability) => getFinancialItemType(item, metadata),
    },
    {
      headerTitle: 'Remaining balance date',
      sortable: true,
      sortKey: 'remainingBalanceDate',
      render: (item: Liability) => formatDate(item.remainingBalanceDate),
    },
    {
      headerTitle: 'Remaining balance',
      sortable: true,
      sortKey: 'remainingBalance',
      render: (item: Liability) =>
        item.remainingBalance != null ? formatMoney(item.remainingBalance, currency) : undefined,
    },
  ];

  return (
    <>
      <FinancialItemGenericTable
        financialItems={liabilities}
        fieldsRenderingRules={fieldsRenderingRules}
        pl={pl}
        onRowClick={onRowClick}
      />
    </>
  );
}
